<template>
	<div>
		<AddNewPlaylist :show-new-playlist-form="showNewPlaylistForm" :project-id="projectIDs" :user-uuid="userStatus.uuid" @close="showNewPlaylistForm = false" />
		<TheVideoPlayerModal :show-video-player-modal="videoPlayerModal.show" :language-code="videoPlayerModal.languageCode" :language="videoPlayerModal.language" :project="videoPlayerModal.project" :poster-mode="false" :downloadable="false" @close="videoPlayerModal.show = false"></TheVideoPlayerModal>
		<InteractiveModal v-if="interactiveModal.show" :show-interactive-modal="interactiveModal.show" :language-code="interactiveModal.languageCode" :language="interactiveModal.language" :project="interactiveModal.project" :poster-mode="false" @closeInteractive="interactiveModal.show = false"></InteractiveModal>
		<q-layout view="hhh lpr ffr">
			<GuestPlaylistHeader :description="playlist.description"></GuestPlaylistHeader>
			<q-page-container>
				<q-page class="justify-center row">
					<div class="content">
						<div class="row playlist">
							<div class="content" style="width: 1140px; max-width: 90vw">
								<ProjectCardsCollection v-if="!projectCardVersionOld" :projects="playlist.projects" :entity="playlist.user.entity.title" :user-status="userStatus" mode="guestPlaylist" :is-sandbox="false"></ProjectCardsCollection>
							</div>
						</div>
					</div>
				</q-page>
			</q-page-container>

			<GuestPlaylistFooter :signature-information="playlist.user"></GuestPlaylistFooter>

			<PlaylistActionsFab :playlist="playlist"></PlaylistActionsFab>
		</q-layout>
	</div>
</template>

<script>
	/* global playlist, userIsLoggedIn */
	// import { mapGetters } from 'vuex';

	import AddNewPlaylist from '../../../cockpit/js/components/global/AddNewPlaylist.vue';
	import InteractiveModal from '../../../cockpit/js/components/global/InteractiveModal.vue';
	import ProjectCardsCollection from '../../../cockpit/js/components/global/project-cards/ProjectCardsCollection.vue';
	import VideoPlayerModal from '../../../cockpit/js/components/global/VideoPlayerModal.vue';
	import GuestPlaylistFooter from '../components/GuestPlaylistFooter.vue';
	import GuestPlaylistHeader from '../components/GuestPlaylistHeader.vue';
	import PlaylistActionsFab from '../components/PlaylistActionsFAB.vue';

	export default {
		name: 'GuestPlaylistView',
		components: {
			ProjectCardsCollection,
			AddNewPlaylist,
			GuestPlaylistHeader,
			GuestPlaylistFooter,
			InteractiveModal,
			TheVideoPlayerModal: VideoPlayerModal,
			PlaylistActionsFab
		},

		data() {
			return {
				playlist: window.playlist,
				fabOpen: false,
				showNewPlaylistForm: false,
				projectIDs: [],
				// userIsLoggedIn: window.userIsLoggedIn,
				projectCardVersionOld: false
			};
		},

		computed: {
			userStatus() {
				return this.$store.getters.getUserStatus;
			},

			// ...mapGetters({
			// 	videoPlayerModal: 'getVideoPlayerModal',
			// 	interactiveModal: 'getInteractiveModal'
			// }),

			videoPlayerModal() {
				return this.$store.getters.getVideoPlayerModal;
			},

			interactiveModal() {
				return this.$store.getters.getInteractiveModal;
			}
		},

		watch: {},
		created() {
			document.body.classList.add('guest-playlist');
			document.body.classList.add('new-theme');
			$(document).on('keydown', e => {
				if (e.key === 'v') {
					this.projectCardVersionOld = !this.projectCardVersionOld;
				}
			});
			if (window.userIsLoggedIn === true) {
				this.$store.dispatch('loadUserStatus');
			}
		},

		mounted() {
			var self = this;
			$('#fabBtn .q-btn-fab').on('focusout', function (event) {
				setTimeout(() => {
					self.fabOpen = false;
				}, 1);
			});
		},

		methods: {
			// alert() {
			// 	this.$q.dialog({
			// 		title: 'FAB',
			// 		message: 'Good job! Keep it going.'
			// 	});
			// },
			// notify(icon) {
			// 	this.$q.notify({
			// 		icon,
			// 		message: 'Successfully added to your playlists!',
			// 		type: 'positive'
			// 	});
			// },
			// showAddNewPlaylistModal() {
			// 	var projects = this.getAllProjects();
			// 	console.log('THE ID:', projects);
			// 	this.projectIDs = projects;
			// 	this.showNewPlaylistForm = true;
			// },
			// getAllProjects() {
			// 	return this.playlist.projects.map(project => {
			// 		return project.id;
			// 	});
			// },
			// isOwnPlaylist() {
			// 	return this.playlist.user_uuid === window.user_uuid;
			// }
		}
	};
</script>

<style lang="scss">
	/* ########## GuestPlaylistView.vue ########## */
	body {
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;
		-webkit-font-smoothing: auto;

		&.new-theme.guest-playlist {
			background-color: white;
		}
	}

	[class^='col-'] {
		border: solid 0;
	}

	.content {
		border: dashed 0;
	}

	.row.playlist {
		margin-top: -24px;
		margin-bottom: 70px;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 5s;
	}

	.q-layout-page {
		background: #eeebe4;
	}

	.fade-enter,
	.fade-leave-to {
		background-color: red;
		opacity: 0;
	}

	.fade-enter-to,
	.fade-leave {
		background-color: green;
		opacity: 1;
	}

	.router-anim-enter-active {
		animation: coming 1s;
		animation-delay: 1s;
		opacity: 0;
	}

	.router-anim-leave-active {
		animation: going 1s;
	}

	@keyframes going {
		from {
			transform: translateX(0);
		}

		to {
			opacity: 0;
			transform: translateX(-50px);
		}
	}

	@keyframes coming {
		from {
			opacity: 0;
			transform: translateX(-50px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	.q-collapsible-closed {
		padding: 0;
	}

	.q-collapsible-opened {
		padding: 0;
	}

	.q-collapsible-opened .q-collapsible-inner {
		box-shadow: initial;
	}

	.q-collapsible-closed .q-collapsible-inner {
		border: initial;
	}

	.q-collapsible-sub-item {
		overflow: hidden;
	}

	a:any-link {
		color: inherit;
		text-decoration: none;
	}

	body.desktop .q-btn-dropdown:focus .q-focus-helper {
		background: none;
	}

	.q-layout-drawer-right .q-collapsible.text-right .q-item-label {
		margin-right: -10px;
		text-align: right;
	}

	/* .content {
	min-height: calc(100vh - 145px);
} */

	.content h4 {
		margin-top: 0;
	}

	.q-chip.avatar .q-chip-side.q-chip-left.row.flex-center {
		margin: 0 -12px;
	}

	.q-chip.avatar {
		margin-right: 18px;
	}

	i.q-icon.q-btn-dropdown-arrow {
		display: none;
	}

	button.q-btn.avatar.q-btn-dropdown {
		padding-right: 56px;
		margin-right: -45px;
	}

	#header {
		padding: 1.5rem;

		/* border: solid 1px; */
		border: inherit;
	}

	#header-image {
		padding: 5px;

		/* border: dotted 1px; */
	}

	#header-text {
		padding: 5px;

		/* border: dotted 1px; */
	}

	#signature {
		margin-top: 70px;
	}

	#signature-image {
		height: 200px;
	}

	header img {
		width: 100%;
	}

	#signature-image img {
		display: block;
		height: 100%;
		margin-right: auto;
		margin-left: auto;
	}

	#signature-text {
		width: auto;
		padding: 10px 20px;
		text-align: center;
	}

	#signature-text .q-body-1 p {
		padding-right: 0 !important;
		padding-left: 0 !important;
		margin-right: 0 !important;
		margin-left: 0 !important;
	}

	@media (width >= 768px) {
		#signature-image {
			height: 200px;
			border-color: #757575;
			border-right: solid 2px;
		}

		#signature-text {
			text-align: initial;
		}

		#imprint-image {
			padding: 0 10px;
		}
	}

	#imprint-links {
		margin-bottom: 20px;
		color: #757575;
		font-family: 'Source Sans Pro', sans-serif;
		font-size: 16px;
		font-weight: 600;
	}

	#imprint-links h5 {
		font-size: 16px;
	}

	.signature {
		padding: 0 20px;
	}

	// .q-item-highlight:hover,
	// .q-item-link:hover,
	// .q-list-highlight > .q-item:hover,
	// .q-list-link > .q-item:hover {
	// 	background: none;
	// }
</style>
